export const chipFilterStyle = theme => ({
  '&.FilterChip': {
    backgroundColor: theme.tokens.ComponentChipFilterBg,
    borderColor: theme.tokens.ComponentChipFilterBorder,
    borderWidth: '1px',
    borderStyle: 'solid',
    color: theme.tokens.ComponentChipFilterColor,
    gap: '4px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '4px',
    paddingBottom: '4px',
    '.MuiChip-deleteIcon': {
      color: theme.tokens.ComponentChipFilterIconColor,
      fontSize: '14px',
      padding: 0,
      margin: 0
    },
    '&:hover': {
      backgroundColor: theme.tokens.ComponentChipHoverBg
    },
    '& .MuiChip-label': {
      fontSize: theme.tokens.ComponentChipFontSize,
      fontFamily: theme.tokens.SemTypeFontBody,
      padding: 0
    }
  }
});